module.exports = __webpack_public_path__ + "0ebfa3c6a81f6a96f9baeeffce83c7b0.png";